import React, { useState } from "react";
import TableReportBlocksPanel from "./TableReportBlocksPanel";
import CompositeReportPanel from "./CompositeReportPanel";
import "./TableReportsBuilder.scss";

function TableReportsBuilder() {
  const [tab, setTab] = useState("tables");

  return (
    <div className="table-reports table-reports--root">
      <div className="table-reports__tabs" role="tablist">
        <button
          type="button"
          role="tab"
          aria-selected={tab === "tables"}
          className={tab === "tables" ? "table-reports__tab table-reports__tab--active" : "table-reports__tab"}
          onClick={() => setTab("tables")}
        >
          Таблицы (несколько источников)
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={tab === "composite"}
          className={tab === "composite" ? "table-reports__tab table-reports__tab--active" : "table-reports__tab"}
          onClick={() => setTab("composite")}
        >
          Сводный отчёт с графиками
        </button>
      </div>
      {tab === "tables" && <TableReportBlocksPanel />}
      {tab === "composite" && <CompositeReportPanel />}
    </div>
  );
}

export default TableReportsBuilder;
